import 'css-chunksrc/client/scenes/workloads/zoomMenu/styles.scss';export default {
  "zoomMenu": "_zoomMenu_p1199_1",
  "button": "_button_p1199_10",
  "disabled": "_disabled_p1199_26"
};